import { createFileRoute } from '@tanstack/react-router';
import {
  loadUserMessages,
  loadUserScreens,
  userListScreen,
  userListSearch,
} from '@/modules/user/route';
import { lazyScreen } from '@/shared/screen';
export const Route = createFileRoute('/_app/seguranca/usuarios/')({
  validateSearch: userListSearch,
  staticData: { screen: userListScreen },
  loader: () => loadUserMessages(),
  component: lazyScreen(loadUserScreens, 'UserListScreen'),
});
